export const MACHINE_LIST = 'MACHINE_LIST';
export const MACHINE_CREATE = 'MACHINE_CREATE';
export const MACHINE_READ = 'MACHINE_READ';
export const MACHINE_UPDATE = 'MACHINE_UPDATE';
export const MACHINE_DELETE = 'MACHINE_DELETE';
